$("#contact_form").submit(function(event) {
    event.preventDefault();

    const $form = $(this);
    const $feedback = $('.js-feedback');
    const $submitBtn = $form.find('button[type="submit"]');

    // Prevenir múltiples envíos
    if ($submitBtn.prop('disabled')) {
        return;
    }

    $feedback.html('').hide();

    // Obtener texto de envío desde data attribute
    const submittingText = $form.data('submitting-text') || 'Enviando...';

    // Deshabilitar botón inmediatamente
    const originalText = $submitBtn.text();
    $submitBtn.prop('disabled', true).text(submittingText);

    // Función para enviar el formulario
    function submitForm(token = null) {
        if (token) {
            $form.find('#g-recaptcha-response').val(token);
        }

        const formData = $form.serialize();

        $.post($form.data('action'), formData, function(response) {
            // Restaurar botón
            $submitBtn.prop('disabled', false).text(originalText);

            if(response.success == 0){
                // Mostrar error
                showContactFeedback(response.message, 'error', true, response.errors || {});
            } else {
                // Éxito - Ocultar formulario y mostrar mensaje de éxito
                $form[0].reset();

                // Ocultar la sección completa del formulario
                $('.contact-form-section').fadeOut(400, function() {
                    // Mostrar el componente de éxito
                    $('#contact-success').removeClass('hidden').addClass('show').hide().fadeIn(600);
                });
            }
        }).fail(function(xhr) {
            // Restaurar botón en caso de error
            $submitBtn.prop('disabled', false).text(originalText);

            // Manejar errores de validación (422), reCAPTCHA (403) o errores del servidor
            if (xhr.status === 403 && xhr.responseJSON) {
                const response = xhr.responseJSON;
                showContactFeedback(response.error || 'Verificación de seguridad fallida.', 'error', true);
            } else if (xhr.status === 422 && xhr.responseJSON) {
                const response = xhr.responseJSON;
                showContactFeedback(response.message || 'Error de validación', 'error', true, response.errors || {});
            } else {
                showContactFeedback('Se ha producido un error. Por favor, inténtelo más tarde.', 'error', true);
            }
        });
    }

    // Verificar si reCAPTCHA v3 está disponible
    if (typeof grecaptcha !== 'undefined' && typeof recaptchaPublicKey !== 'undefined' && recaptchaPublicKey) {
        try {
            const formType = $form.find('input[name="form_type"]').val() || 'contact_form';
            const action = `contact_${formType}`;

            grecaptcha.ready(function() {
                try {
                    grecaptcha.execute(recaptchaPublicKey, {action: action}).then(function(token) {
                        submitForm(token);
                    }).catch(function(error) {
                        console.warn('reCAPTCHA error:', error);
                        // Si falla reCAPTCHA, enviar sin token
                        submitForm();
                    });
                } catch (e) {
                    console.warn('reCAPTCHA execution error:', e);
                    // Si hay error, enviar sin token
                    submitForm();
                }
            });
        } catch (e) {
            console.warn('reCAPTCHA not available:', e);
            // Si reCAPTCHA no está disponible, enviar sin token
            submitForm();
        }
    } else {
        // reCAPTCHA no está habilitado, enviar directamente
        submitForm();
    }
});

function showContactFeedback(message, type = 'success', expires = false, errors = {}) {
    const feedback = document.querySelector('.js-feedback');
    feedback.innerHTML = '';

    const container = document.createElement('div');
    container.className = `p-4 rounded-lg mb-2 text-sm ${
        type === 'success' ? 'text-green-800' :
        type === 'warning' ? 'text-yellow-800' :
        'text-red-800' // error
    }`;

    if(Object.keys(errors).length > 0){
        const ul = document.createElement('ul');
        ul.className = 'list-disc pl-5';
        Object.values(errors).forEach(errArr => {
            errArr.forEach(err => {
                const li = document.createElement('li');
                li.innerText = err;
                ul.appendChild(li);
            });
        });
        container.appendChild(ul);
    } else {
        container.innerText = message;
    }

    feedback.appendChild(container);
    $(feedback).fadeIn();

    if(expires){
        setTimeout(() => {
            feedback.innerHTML = '';
            $(feedback).fadeOut();
        }, 6000);
    }
}

// Tooltip positioning
document.addEventListener('DOMContentLoaded', () => {
    const MOBILE_BREAKPOINT = 640;
    const GAP = 8;

    const wrappers = document.querySelectorAll('[data-tooltip-wrapper]');
    if (!wrappers.length) return;

    wrappers.forEach(wrapper => {
        const button = wrapper.querySelector('button');
        const tooltip = wrapper.querySelector('[data-tooltip]');

        if (!button || !tooltip) return;

        let isVisible = false;
        let resizeTimeout = null;
        let isHoveringButton = false;
        let isHoveringTooltip = false;

        function isMobile() {
            return window.innerWidth < MOBILE_BREAKPOINT;
        }

        function updateTooltipPosition() {
            const mobile = isMobile();
            const buttonRect = button.getBoundingClientRect();

            if (mobile) {
                // Mobile: fixed, centrado horizontalmente, posicionado verticalmente respecto al botón
                tooltip.style.position = 'fixed';
                tooltip.style.left = '50%';
                tooltip.style.right = 'auto';
                tooltip.style.top = `${buttonRect.top - GAP}px`;
                tooltip.style.bottom = 'auto';
                tooltip.style.transform = 'translate(-50%, -100%)';
                tooltip.style.width = 'calc(100vw - 2rem)';
                tooltip.style.maxWidth = 'calc(100vw - 2rem)';
            } else {
                // Desktop: absolute, posicionamiento normal
                tooltip.style.position = '';
                tooltip.style.left = '';
                tooltip.style.right = '';
                tooltip.style.top = '';
                tooltip.style.bottom = '';
                tooltip.style.transform = '';
                tooltip.style.width = '';
                tooltip.style.maxWidth = '';
            }
        }

        function showTooltip() {
            if (isVisible) return;

            isVisible = true;
            updateTooltipPosition();

            // Hacer visible y clickeable
            tooltip.classList.remove('opacity-0', 'invisible', 'pointer-events-none');
            tooltip.classList.add('opacity-100', 'visible', 'pointer-events-auto');
        }

        function hideTooltip() {
            if (!isVisible) return;

            isVisible = false;
            isHoveringButton = false;
            isHoveringTooltip = false;

            // Ocultar y deshabilitar clicks
            tooltip.classList.remove('opacity-100', 'visible', 'pointer-events-auto');
            tooltip.classList.add('opacity-0', 'invisible', 'pointer-events-none');
        }

        function checkShouldHide() {
            // Solo ocultar si no estamos sobre el botón ni sobre el tooltip
            if (!isHoveringButton && !isHoveringTooltip) {
                hideTooltip();
            }
        }

        function handleResize() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                if (isVisible) {
                    updateTooltipPosition();
                }
            }, 100);
        }

        function handleScroll() {
            if (isVisible && isMobile()) {
                updateTooltipPosition();
            }
        }

        function handleClickOutside(e) {
            if (!isVisible) return;

            // Si el click es dentro del tooltip o del botón, no hacer nada
            if (tooltip.contains(e.target) || button.contains(e.target)) {
                return;
            }

            // Si el click es fuera del wrapper completo, cerrar
            if (!wrapper.contains(e.target)) {
                hideTooltip();
            }
        }

        // Eventos del botón
        button.addEventListener('mouseenter', () => {
            isHoveringButton = true;
            showTooltip();
        });

        button.addEventListener('mouseleave', () => {
            isHoveringButton = false;
            // No cerramos automáticamente al salir del botón
        });

        button.addEventListener('focus', showTooltip);
        button.addEventListener('blur', () => {
            // No cerramos automáticamente
        });

        // Eventos del tooltip
        tooltip.addEventListener('mouseenter', () => {
            isHoveringTooltip = true;
        });

        tooltip.addEventListener('mouseleave', () => {
            isHoveringTooltip = false;
            // Cerrar cuando sales del tooltip
            hideTooltip();
        });

        // Click en el botón - solo toggle en móvil, en desktop solo con hover
        button.addEventListener('click', (e) => {
            if (isMobile()) {
                e.preventDefault();
                e.stopPropagation();
                if (isVisible) {
                    hideTooltip();
                } else {
                    showTooltip();
                }
            }
        });

        // Prevenir que clicks dentro del tooltip lo cierren
        tooltip.addEventListener('click', (e) => {
            e.stopPropagation();
        });

        // Click fuera para cerrar (móvil y desktop)
        document.addEventListener('click', handleClickOutside);

        // Eventos globales
        window.addEventListener('resize', handleResize, { passive: true });
        window.addEventListener('scroll', handleScroll, { passive: true });
    });
});

// =========================================
// DISFERA MODAL
// =========================================
$(document).ready(function() {
    // Modal controls
    const $modal = $('.disfera-modal');
    const $modalClose = $('.disfera-modal-close');

    if ($modal.length === 0) return; // Salir si no existe el modal

    // Abrir modal - usar delegación de eventos
    $(document).on('click', '.disfera-modal-trigger', function(e) {
        e.preventDefault();
        $modal.removeClass('hidden').addClass('flex');
        $('body').css('overflow', 'hidden');
    });

    // Cerrar modal
    function closeDisferaModal() {
        $modal.addClass('hidden').removeClass('flex');
        $('body').css('overflow', '');
        $('.js-feedback-disfera').html('').hide();
    }

    $modalClose.on('click', closeDisferaModal);

    // Cerrar al hacer clic fuera del contenido
    $modal.on('click', function(e) {
        if ($(e.target).is($modal)) {
            closeDisferaModal();
        }
    });

    // Cerrar con tecla Escape
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && !$modal.hasClass('hidden')) {
            closeDisferaModal();
        }
    });

    // Form submission para formulario Disfera
    $(document).on('submit', "#disfera_contact_form", function(event) {
        event.preventDefault();

        const $form = $(this);
        const $feedback = $('.js-feedback-disfera');
        const $submitBtn = $form.find('button[type="submit"]');

        // Prevenir múltiples envíos
        if ($submitBtn.prop('disabled')) {
            return;
        }

        $feedback.html('').hide();

        // Obtener mensajes de error y textos desde data attributes
        const errorEmail = $form.data('error-email') || 'Por favor, introduce un email válido.';
        const errorPhone = $form.data('error-phone') || 'Por favor, introduce un teléfono válido (solo números).';
        const errorPrivacy = $form.data('error-privacy') || 'Debes aceptar la Política de Privacidad para continuar.';
        const submittingText = $form.data('submitting-text') || 'Enviando...';

        // Validaciones del lado del cliente
        const email = $('#disfera-email').val().trim();
        const phone = $('#disfera-phone').val().trim();
        const privacyChecked = $('#disfera-privacy-consent').is(':checked');

        // Validar formato de email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            showDisferaFeedback(errorEmail, 'error', true);
            return;
        }

        // Validar que el teléfono solo contenga números (y opcionalmente +)
        const phoneRegex = /^[\d+\s\-()]+$/;
        const cleanPhone = phone.replace(/[\s\-()]/g, '');
        if (!phoneRegex.test(phone) || cleanPhone.length < 9 || !/\d/.test(cleanPhone)) {
            showDisferaFeedback(errorPhone, 'error', true);
            return;
        }

        // Validar que se acepte la política de privacidad
        if (!privacyChecked) {
            showDisferaFeedback(errorPrivacy, 'error', true);
            return;
        }

        // Deshabilitar botón INMEDIATAMENTE después de validaciones
        const originalText = $submitBtn.text();
        $submitBtn.prop('disabled', true).text(submittingText);

        // Función para enviar el formulario
        function submitForm(token = null) {
            if (token) {
                $('#disfera-g-recaptcha-response').val(token);
            }

            const formData = $form.serialize();

            $.post($form.data('action'), formData, function(response) {
                // Restaurar botón
                $submitBtn.prop('disabled', false).text(originalText);

                if(response.success == 0){
                    // Mostrar error
                    showDisferaFeedback(response.message, 'error', true, response.errors || {});
                } else {
                    // Éxito
                    $form[0].reset();
                    showDisferaFeedback(response.message, 'success', true);
                    setTimeout(function() {
                        closeDisferaModal();
                    }, 2000);
                }
            }).fail(function(xhr) {
                // Restaurar botón en caso de error
                $submitBtn.prop('disabled', false).text(originalText);

                // Manejar errores de validación (422), reCAPTCHA (403) o errores del servidor
                if (xhr.status === 403 && xhr.responseJSON) {
                    const response = xhr.responseJSON;
                    showDisferaFeedback(response.error || 'Verificación de seguridad fallida.', 'error', true);
                } else if (xhr.status === 422 && xhr.responseJSON) {
                    const response = xhr.responseJSON;
                    showDisferaFeedback(response.message || 'Error de validación', 'error', true, response.errors || {});
                } else {
                    showDisferaFeedback('Se ha producido un error. Por favor, inténtelo más tarde.', 'error', true);
                }
            });
        }

        // Verificar si reCAPTCHA v3 está disponible
        if (typeof grecaptcha !== 'undefined' && typeof recaptchaPublicKey !== 'undefined' && recaptchaPublicKey) {
            try {
                grecaptcha.ready(function() {
                    try {
                        grecaptcha.execute(recaptchaPublicKey, {action: 'contact_disfera'}).then(function(token) {
                            submitForm(token);
                        }).catch(function(error) {
                            console.warn('reCAPTCHA error:', error);
                            submitForm();
                        });
                    } catch (e) {
                        console.warn('reCAPTCHA execution error:', e);
                        submitForm();
                    }
                });
            } catch (e) {
                console.warn('reCAPTCHA not available:', e);
                submitForm();
            }
        } else {
            // reCAPTCHA no está habilitado, enviar directamente
            submitForm();
        }
    });

    // Función para mostrar feedback (adaptada de contact.js)
    function showDisferaFeedback(message, type = 'success', expires = false, errors = {}) {
        const $feedback = $('.js-feedback-disfera');
        $feedback.html('');

        const $container = $('<div>').addClass(`p-4 rounded-lg mb-2 text-sm ${
            type === 'success' ? 'bg-green-100 text-green-800' :
            type === 'warning' ? 'bg-yellow-100 text-yellow-800' :
            'bg-red-100 text-red-800' // error
        }`);

        if(Object.keys(errors).length > 0){
            const $ul = $('<ul>').addClass('list-disc pl-5');
            Object.values(errors).forEach(errArr => {
                errArr.forEach(err => {
                    $ul.append($('<li>').text(err));
                });
            });
            $container.append($ul);
        } else {
            $container.text(message);
        }

        $feedback.append($container).fadeIn();

        if(expires){
            setTimeout(() => {
                $feedback.html('').fadeOut();
            }, 6000);
        }
    }
});
